import { Box } from "@chakra-ui/react";
import OrganizationServerTable from "./serversTable";
import { ORGANIZATION_SERVER } from "./constants";

const OrganizationServerPricing = ({ showHeader = true }: { showHeader?: boolean }) => {
  return (
    <Box id="dedicated-server-for-organization">
      <OrganizationServerTable {...ORGANIZATION_SERVER} showHeader={showHeader} />
    </Box>
  );
};

export default OrganizationServerPricing;
